import { useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { rdEase } from './RedesignMotion';

export interface FaqItem {
  question: string;
  answer: string;
}

interface RedesignFaqProps {
  items: FaqItem[];
  defaultOpen?: number;
}

export function RedesignFaq({ items, defaultOpen = 0 }: RedesignFaqProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);
  const reduce = useReducedMotion();

  return (
    <div className="faq">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <motion.div
            key={item.question}
            className={cn('item', open && 'open')}
            initial={reduce ? false : { opacity: 0, y: 12 }}
            whileInView={reduce ? undefined : { opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.45, delay: index * 0.06, ease: rdEase }}
            whileHover={reduce ? undefined : { y: -2 }}
          >
            <button
              type="button"
              className="q w-full text-left bg-transparent border-0 p-0"
              onClick={() => setOpenIndex(open ? null : index)}
              aria-expanded={open}
            >
              {item.question}
            </button>
            {reduce ? (
              open ? <div className="a rd-faq-answer">{item.answer}</div> : null
            ) : (
              <AnimatePresence initial={false}>
                {open && (
                  <motion.div
                    key="answer"
                    className="a rd-faq-answer"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.28, ease: rdEase }}
                    style={{ overflow: 'hidden' }}
                  >
                    {item.answer}
                  </motion.div>
                )}
              </AnimatePresence>
            )}
          </motion.div>
        );
      })}
    </div>
  );
}
